/* eslint-disable sonarjs/cognitive-complexity */
import React from 'react';

import faq1 from '../../assets/faq-1.png';
import faq2 from '../../assets/faq-2.png';
import faq3 from '../../assets/faq-3.png';
import faq4 from '../../assets/faq-4.png';
import faq5 from '../../assets/faq-5.png';
import faq6 from '../../assets/faq-6.png';
import faq7 from '../../assets/faq-7.png';
import faq8 from '../../assets/faq-8.png';
import { useDisplay } from '../../hook/useDisplay';
import { ButtonGrow } from '../grow/style';
import {
  Box,
  Container,
  ContainerImg,
  ContainerText,
  ContainerTextResponsive,
  ContainerTextTitle,
  Content,
  ContentText,
  Desc,
  Item,
  ResponsiveContainer,
  ResponsiveContent,
  Title,
} from './style';

const MAP_INFORMATIONS = [
  {
    id: 1,
    img: faq1,
    title: 'A decisão de transformar',
    desc: 'Empreender exige mais do que ideias. Exige atitude, coragem e preparo. O Empretec é o passo certo para quem quer sair do plano e ir pra ação.',
    bgColor: '#F73450',
    positionImage: 'left',
    textColor: '#fff',
  },
  {
    id: 2,
    img: faq2,
    title: 'Escolha seu caminho',
    desc: 'Empretec, Empretec Rural, Empretec Startup ou Empretec Arena. Cada versão foi criada para se alinhar ao seu perfil e objetivo de negócio.',
    bgColor: '#8DE1FF',
    positionImage: 'right',
    textColor: '#000',
  },
  {
    id: 3,
    img: faq3,
    title: 'Quem pode participar',
    desc: 'Ter 18 anos ou mais (ou 16 com emancipação), disponibilidade total e boas condições físicas e emocionais para a imersão. ',
    bgColor: '#C0F9C0',
    positionImage: 'right',
    textColor: '#000',
  },
  {
    id: 4,
    img: faq4,
    title: 'Disponibilidade total',
    desc: 'O seminário exige foco. São dias intensos, com tarefas práticas e desafios reais. Prepare-se para viver o Empretec por inteiro.',
    bgColor: '#215DF4',
    positionImage: 'left',
    textColor: '#fff',
  },
  {
    id: 5,
    img: faq5,
    title: 'Metodologia exclusiva',
    desc: 'Baseado nas 10 CCEs — Características de Comportamento Empreendedor — o Empretec combina teoria, prática e desafio real.',
    bgColor: '#FCEBAC',
    positionImage: 'left',
    textColor: '#000',
  },
  {
    id: 6,
    img: faq6,
    title: 'Sobre o investimento',
    desc: 'O valor varia por estado. Acesse a agenda regional e consulte condições. O retorno? Muito maior do que o custo.',
    bgColor: '#4EAD4E',
    positionImage: 'left',
    textColor: '#fff',
  },
  {
    id: 7,
    img: faq7,
    title: 'O que você desenvolve',
    desc: 'Visão clara de negócios, segurança nas decisões, postura de liderança, foco em inovação, rede de contatos e ação com propósito.',
    bgColor: '#C5EAFF',
    positionImage: 'left',
    textColor: '#000',
  },
  {
    id: 8,
    img: faq8,
    title: 'A virada de chave',
    desc: 'Você entra com vontade. Sai com atitude. O Empretec ativa seu potencial e prepara você para empreender com impacto real.',
    bgColor: '#801080',
    positionImage: 'left',
    textColor: '#fff',
  },
];
function NewEmpretecForYou() {

  const { breakpointController } = useDisplay();


  const handleMenuClick = React.useCallback(() => {
    const section = document.getElementById('7');
    const offset = 94;
    const elementPosition =
      section.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  }, []);

  const isMobile = !breakpointController.inDesktop &&
    !breakpointController.inDesktopLarge && !breakpointController.inTablet

  return (
    <div id="5">
      <ContainerTextTitle>
        <p>
          Por que o Empretec <strong>é para você?</strong> <br />
          Sua <strong>jornada empreendedora </strong> começa agora.
        </p>
      </ContainerTextTitle>
      <Container>
        {isMobile ? (
          <ResponsiveContainer>
            {MAP_INFORMATIONS.map((info, index) => (
              <ResponsiveContent>
                <img src={info.img} alt="imagem" />
                <ContainerTextResponsive bgColor={info.bgColor}>
                  <Title color={info.textColor}>{info.title}</Title>
                  <Desc color={info.textColor}>{info.desc}</Desc>
                </ContainerTextResponsive>
              </ResponsiveContent>
            ))}
          </ResponsiveContainer>
        ) : (
          <Content>
            {MAP_INFORMATIONS.map((info, index) => {
              const isLeft = index % 2 === 0;
              return (
                <Item
                  key={info.id}
                  align={isLeft ? 'flex-start' : 'flex-end'}
                  isLeftAligned={isLeft}
                >
                  <Box>
                    {info.positionImage === 'left' && (
                      <ContainerImg>
                        <img src={info.img} alt="imagem" />
                      </ContainerImg>
                    )}
                    <ContainerText
                      bgColor={info.bgColor}
                      align={isLeft ? 'flex-start' : 'flex-end'}
                    >
                      <ContentText>
                        <Title color={info.textColor}>{info.title}</Title>
                        <Desc color={info.textColor}>{info.desc}</Desc>
                      </ContentText>
                    </ContainerText>
                    {info.positionImage === 'right' && (
                      <ContainerImg>
                        <img src={info.img} alt="imagem" />
                      </ContainerImg>
                    )}
                  </Box>
                </Item>
              );
            })}
          </Content>
        )}
      </Container>

      <div
        style={{ margin: '2em 0', display: 'flex', justifyContent: 'center' }}
      >
        <ButtonGrow onClick={() => handleMenuClick()}>
          Quero viver essa experiência
        </ButtonGrow>
      </div>
    </div>
  );
}

export default NewEmpretecForYou;
